/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-15 15:44:24
 * @Explain: 数据排序逻辑
 */

import { SortEnum } from '@/definition/common/tdesign.d';

// 根据取得key的值排序
export const onSort = (
  arr: any[],
  key: string,
  sortType: SortEnum = SortEnum.ASC,
) => {
  switch (sortType) {
    case SortEnum.ASC: // 升序 - 从小到大
      return arr.sort((a, b) => a[key] - b[key]);
    case SortEnum.DESC: // 降序 - 从大到小
      return arr.sort((a, b) => b[key] - a[key]);
  }
};

/**
 * 排序
 * 中文, 英文, 数字字符串混排
 * 按照数值大小对数值字符串排序, 且英文排在数字后面, 中文前面
 *
 * 数字在前, 中文其次, 英文最后
 * 数字按照字符串的 unicode 编码进行比较, 而不是数值大小比较
 * 中文是按照拼音顺序进行排序的
 * 英文也是按照 unicode 编码排序的
 */
// 中文&英文 按照英文字母顺序排序
export const onLocaleCompareSort = (
  arr: any[],
  key: string,
  sortType: SortEnum = SortEnum.ASC,
) => {
  return arr.sort((a: any, b: any) => {
    const aa = a[key]?.toLocaleLowerCase();
    const bb = b[key]?.toLocaleLowerCase();
    switch (sortType) {
      case SortEnum.ASC: // 升序
        return aa?.localeCompare(bb);
      case SortEnum.DESC: // 降序
        return bb?.localeCompare(aa);
    }
  });
};

// 如果需要支持带空格的中文
const getStringType = (label: string) => {
  if (label && /^\d+$/.test(label)) {
    return 0; // 数字
  } else if (label && /^[A-Za-z]+$/.test(label)) {
    return 1; // 英文
  } else if (label && /^[\u4e00-\u9fa5]+$/.test(label)) {
    return 2; // 中文
  } else {
    return 3; // 其他类型
  }
};

/** 按照产品规则 - （数字 - 英文 - 中文） 排序 */
export const onArrSort = (arr: any[], key: string) => {
  const numArr: any[] = [];
  const enArr: any[] = [];
  const zhArr: any[] = [];
  const otherArr: any[] = [];
  arr.forEach((item) => {
    const type = getStringType(item[key].charAt(0, 1));
    switch (type) {
      case 0:
        numArr.push(item);
        break;
      case 1:
        enArr.push(item);
        break;
      case 2:
        zhArr.push(item);
        break;
      default:
        otherArr.push(item);
        break;
    }
  });
  return [
    ...onLocaleCompareSort(numArr, key),
    ...onLocaleCompareSort(enArr, key),
    ...onLocaleCompareSort(zhArr, key),
    ...onLocaleCompareSort(otherArr, key),
  ];
};
